import { Moment } from "moment";

export interface IDefaultShippingOrderModel {
  id: string;
  shippingCode: string;
  abbreviation: string;
  startDate: Moment;
  inShippingSpaceState: string;
  billLadingCode: string;
  containerTypeList: [];
  boxNumber: string;
  sealNo: string;
  allocationStatus: AllocationState;
  generatedCustomsDeclarationContract: string;
  bookingOrderCodes: string;
}

export interface IJobPositionModel {
  id: string;
  name: string;
  createdAt: string;
}

export interface IRoleModel {
  id: string;
  name: string;
  menus: IMenuModel[];
  createdAt?: string;
}

export interface IResourceModel {
  id: string;
  name: string;
}

export interface IMenuModel {
  id: string;
  name: string;
  title: string;
  buttonList: IButtonModel[];
  children: IMenuModel[];
}

export interface IButtonModel {
  id: string;
  name: string;
}

export interface IUserModel {
  id: string;
  username: string;
  password: string;
  telephone: null;
  staffCode: null;
  name: string;
  state?: number;
  jobPositionId: string;
  code: string;
  roleId: string;
  viewId: string;
  accountType?: string;
  receiptType?: string;
}

export interface IInventoryPlanModel {
  id: string;
  deliveryCode: string;
  storageLayerNames: string;
  createdAt: string;
  state: string;
  completedDate: string;
}

export interface IDeliveryNoteModel {
  id: string;
  code: string;
  inStateDesc: string;
  outStateDesc: string;
  sellerName: string;
  purchaserName: string;
  logisticsClerkName: string;
  storageLayerNames: string;
  companyCode: string;
  customerCode: string;
  customerName: string;
  remark: string;
  createdAt: string;
  lastReleaseTime: string;
  estimatedSailingSchedule: string;
  daysInStock: number;
  reserved: boolean;
  // estimatedInStorageDateEnd: Moment;
  // estimatedInStorageDateStart: Moment;
  // estimatedNextDeliveryDate: Moment;
  allStorageLayerList: string;
  inState: IDeliveryNoteStateModel;
  outState: IDeliveryNoteStateModel;
  canUpload: boolean;
  customerAbbreviation: string;
  maxVolume: string;
  popoverVisible: boolean;
}

export interface IDeliveryNoteStateModel {
  name: string;
  desc: string;
}

export interface IDeliveryNoteStorageLayerModel {
  id: string;
  //预计在仓时间开始
  estimatedInStorageDateStart: string;
  //预计在仓时间结束
  estimatedInStorageDateEnd: string;
  //预计下次发货时间
  estimatedNextDeliveryDate: string;
  //备注
  remark: string;
}

export interface IAddShippingModel {
  id: string;
  sellerId: string;
  customerId: string;
  shippingCode: string;
  code: string;
  name: string;
  abbreviation: string;
  customerAddress: string;
  tel: string;
  country: string;
  departures: string;
  tradeCountry: string;
  departure: string;
  transportation: string;
  destinationCountry;
  deliveryCountry;
  portDischarge: string;
  internationalTradeTerms: string;
  payment: string;
  paymentDetails: string;
  ladingType: string;
  notifier: string;
  notifierAddress: string;
  startDate: string;
  combinedContainer: boolean;
}

export interface ICustomerModel {
  id: string;
  code: string;
  name: string;
  abbreviation: string;
  customerAddress: string;
  address?: string;
  tel: string;
  country: string; // 客人国家
  nation: string; // 原产国
  departures: string;
  tradeCountry: string; // 贸易国
  departure: string;
  transportation: string; // 运输方式
  destinationCountry; // 目的国
  deliveryCountry; // 抵达国
  portDischarge: string;
  internationalTradeTerms: string;
  payment: string;
  paymentDetails: string;
  ladingType: string;
  notifier: string;
  notifierAddress: string;
  fivePiecesSetCompanyName: string; // 五件套公司名
  fivePiecesSetCompanyAddress: string; // 五件套公司地址
  fivePiecesSetCompanyOtherInfo: string; // 五件套公司其他信息
}

//系统配置柜型
export interface IContainerTypeModel {
  id: string;
  name: string;
  createdAt: Date;
  value: string;
}

//编辑柜型模型1
export interface IContainerTypesModel {
  id: string;
  name: string;
  containerNumber: string;
  sealNumber: string;
  deliveryList: string;
}

//新增柜型
export interface ITypeModel {
  id: string;
  name: string;
  value: string;
}

export interface IStorageModel {
  id: string;
  name: string;
  storageRowType: string;
  storageType: string;
  children: [];
}

export interface IStorageLayerDeliveryNoteInfoModel {
  storageColumnId: string;
  storageColumnName: string;
  storageColumnRemark: string;
  storageRowName: string;
  items: IStorageLayerDeliveryNoteItemModel[];
}

export interface IStorageLayerDeliveryNoteItemModel {
  storageLayerId: string;
  storageLayerName: string;
  deliveryNoteCodes: string[];
  reservedDeliveryNoteCodes: string[];
  inStorageVolume: any;
  noInStorageVolume: any;
}

export interface IHqPackingListModel {
  id: string;
  code: string;
  createdAt: string;
  factoryName: string;
  inboundStateDate: string;
  stateName: string;
  deliveryStartTime: Date;
  deliveryEndTime: Date;
  canCreateDeliveryTime: boolean;
  canUpdateDeliveryTime: boolean;
  remark: string;
  carriageVehicleType: string;
  warehouseReceiptId: string;
  factoryDeliveryNoteId: string;
  receiveListId: string;
  purchaserName: string;
  state: IHqPackingListStateModel;
  auditState: IHqPackingListAuditStateModel;
  type: string;
  actualWarehouseInTime: string;
  matched: boolean;
  bePackedOfPackingList: boolean;
  hasThereEverBeenAnAbnormalCustomsPacking: boolean;
  ossUrlIds: string[];
  purchaseOrderNumber: string[];
  whoConfirm: string;
  confirmType: number;// 1:手动入库  2:扫码入库
  accountPeriodStartTime: Date;
}

export interface IHqPackingListAuditStateModel {
  name: string;
  desc: string;
  canCreateDeliveryList: boolean;
}

export interface IHqPackingListStateModel {
  name: string;
  desc: string;
  canCreateOrUpdateDeliveryTime: boolean;
  canCreateOrGetFactoryDeliveryNote: boolean;
  canUpdateHqPackingList: boolean;
  canPackageManagement: boolean;
  canInStorageHandleProblem: boolean;
  canGetProblemRecord: boolean;
  canConfirmInStorage: boolean;
  canReUploadHqPackingList: boolean;
  canWarehousing: boolean;
  notInStorage: boolean;
  canDownloadInventoryList: boolean;
  canUpdateInventoryList: boolean;
}

export interface IFactoryLoadingPlan {
  id: string;
  code: string;
  customerId: string;
  customerAbbr: string;
  shippingOrderId: string;
  shippingOrderCode: string;
  state: AllocationState;
  remark: string;
  createdAt: string;
  containerTypeInfos: string[];
  unreleasedContainerTypeQuantity: number;
  logisticsClerkId: string;
  logisticsClerkName: string;
  estimatedSailingSchedule: string;
  billOfLadingCode: string;
  combinedContainer: boolean;
  sellerId: string;
  bookingOrderCodes: string;
  companyCode: string;
  declaration: string;
}

export interface ISupplierModel {
  id: string;
  code: string;
  name: string;
  abbreviation: string;
  generalCode: string;
  generalAbbreviation: string;
  address: string;
  purchaser: string;
  accountant: string;
  marker: string;
  orderAuditor: string;
  payment: string;
  accountPeriod: string;
  depositPercent: string;
  longTermDeposit: string;
  popoverVisible?: boolean;
  supplierProducts: SupplierProductModel[];
}

export class SupplierProductModel {
  id: string;
  description: string;
  declarationDescription: string;
  invoiceUnit: string;
  combinationUnit: string;
  special: boolean;
}
export class AllocationState {
  name: string;
  desc: string;
}
